import ReceiptLayout from '@/components/MedicalReceipt/ReceiptLayout';
import React from 'react';
import TicketMainImage from '../../assets/confirmDeparture/ticket_main.png';
import ImageCover from '@/components/MedicalDepartureWifi/ImageCover';
import styled from 'styled-components';
import ChevronIcon from '../../assets/confirmDeparture/icon_chevron.png';
import { ICON_DEPARTURE } from '@repo/assets';

function MedicalKorDeparture() {
  return (
    <ReceiptLayout>
      <ImageCover img={TicketMainImage} />
      <Container>
        <Header>
          <Title>
            <img src={ICON_DEPARTURE} alt='' />
            출국 여부 선택
          </Title>
          <Description>출국 상태에 맞는 버튼을 클릭해주세요.</Description>
        </Header>
        <LinkButtonWrapper>
          <LinkButton href='/kor-departure-location'>
            <LinkName>출국 예정이에요</LinkName>
            <img
              src={ChevronIcon}
              alt='와이파이 연결 페이지로 이동하기'
              width={24}
              height={24}
            />
          </LinkButton>
          <LinkButton href='/upload-ticket'>
            <LinkName>이미 출국했어요</LinkName>
            <img
              src={ChevronIcon}
              alt='와이파이 연결 페이지로 이동하기'
              width={24}
              height={24}
            />
          </LinkButton>
        </LinkButtonWrapper>
      </Container>
    </ReceiptLayout>
  );
}

const Container = styled.section`
  width: calc(100% + 40px);
  margin-top: 120px;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 20px 20px 0 0;
  z-index: 10;
`;

const Header = styled.header`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
`;

const Title = styled.h2`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 24px;
  font-weight: 700;
  color: #3a3b3e;

  & > img {
    width: 36px;
    height: 36px;
  }
`;

const Description = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #80848a;
`;

const LinkButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const LinkButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 24px;
  border: 1px solid #e5e6e8;
  border-radius: 12px;
`;

const LinkName = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #3a3b3e;
  line-height: 24px;
`;

export default MedicalKorDeparture;
